import { UpdatePaymentModalController } from './updatePaymentModal.controller';
import template from './updatePaymentModal.html';
import './updatePaymentModal.scss';

export const LaunchUpdatePaymentModalService = angular
    .module('app.components.updatePayment.modal.launchUpdatePaymentModalService', [
        'ngMaterial',
        UpdatePaymentModalController
    ]).service('launchUpdatePaymentService', (
        $mdDialog
    ) => {
        return {
            launchModal: (editMode, prefillData, ev) => {
                return $mdDialog.show({
                    controller: 'UpdatePaymentModalController',
                    template,
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    targetEvent: ev,
                    locals: {
                        editMode,
                        prefillData
                    }
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/updatePayment/updatePaymentModal/launchUpdatePaymentModal.service.js